"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useCategories", {
  enumerable: true,
  get: function get() {
    return _useCategories["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
exports["default"] = void 0;
var _useCategories = _interopRequireDefault(require("./useCategories"));
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _default = _useCategories["default"];
exports["default"] = _default;